import TestOptions from "./testOptions";
import QuestionContent from "./QuestionContent";
import q from "../styles/components/examQuestion.module.scss";
import { shouldShowQuestionScore, canShowOptionsInline } from "../assets/utils/utils";
import { useTestQuestionAnswer } from "../hooks/useTestQuestionAnswer";
import useMediaQuery from "../hooks/useMediaQuery";
import { RESPONSIVE_LAYOUT_MAX_WIDTH } from "../assets/utils/viewport";

const TestQuestion = ({
    id,
    quNo,
    audioURL,
    imageURL,
    question,
    score,
    options,
    body,
    isRank,
    quizType,
    attemptID,
    examDataAttempt,
    userAnswered,
    answerResHandler,
    sheetMode = "active",
    allowInQuestionAnswer = false,
}) => {
    const showScore = shouldShowQuestionScore(quizType, isRank);
    const isCompactViewport = useMediaQuery(`(max-width: ${RESPONSIVE_LAYOUT_MAX_WIDTH}px)`);
    const optionsInline = !isCompactViewport && canShowOptionsInline(options);
    const canAnswerInQuestion = Boolean(
        allowInQuestionAnswer && attemptID && answerResHandler
    );
    const {
        activeBtn,
        onOptionClick,
        optionsLocked,
        pendingClearOptionId,
        confirmClearAnswer,
        cancelClearAnswer,
        isClearing,
    } = useTestQuestionAnswer({
        questionId: id,
        attemptID,
        examDataAttempt,
        userAnswered,
        answerResHandler,
        sheetMode,
    });
    const interactive = canAnswerInQuestion && !optionsLocked;

    return (
        <article className={q.card} key={id}>
            <header className={q.header}>
                <p className={q.number}>{`سوال ${quNo}`}</p>
                {showScore && <p className={q.score}>{`${score} نمره`}</p>}
            </header>
            <QuestionContent
                body={body}
                imageURL={imageURL}
                audioURL={audioURL}
                question={question}
                id={id}
            />
            {options?.length > 0 && (
                <ul className={optionsInline ? q.optionsInline : q.options}>
                    {options.map((data) => (
                        <TestOptions
                            key={data.id}
                            id={data.id}
                            optionNo={data.option_number}
                            optionBody={data.body}
                            layout={optionsInline ? "inline" : "block"}
                            imageURL={data.image}
                            audioURL={data.voice}
                            selected={activeBtn === data.id}
                            interactive={interactive}
                            onSelect={() => onOptionClick(data.id)}
                            showClearConfirm={pendingClearOptionId === data.id}
                            onConfirmClear={confirmClearAnswer}
                            onCancelClear={cancelClearAnswer}
                            isClearing={isClearing}
                        />
                    ))}
                </ul>
            )}
        </article>
    );
};

export default TestQuestion;
